module.exports = __webpack_public_path__ + "static/media/1.35210ada.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/16010/1.jpg
// module id = 503
// module chunks = 0